export function handler(event) {
  const current = event.target.id;
  const flag = current.indexOf('_', 9);
  let row = Number(current.substring(9, flag));
  let col = Number(current.substring(flag + 1));
  if (event.keyCode === 37) {
    // left
    event.preventDefault();
    col -= 1;
    while (document.getElementById(`input_num${row}_${col}`).disabled === true)
      col -= 1;
    document.getElementById(`input_num${row}_${col}`).focus();
    return false;
  }
  if (event.keyCode === 38 && event.target.type !== 'select') {
    // up
    event.preventDefault();
    row -= 1;
    while (document.getElementById(`input_num${row}_${col}`).disabled === true)
      row -= 1;
    document.getElementById(`input_num${row}_${col}`).focus();
    return false;
  }
  if (event.keyCode === 39) {
    // right
    event.preventDefault();
    col += 1;
    while (document.getElementById(`input_num${row}_${col}`).disabled === true)
      col += 1;
    document.getElementById(`input_num${row}_${col}`).focus();
    return false;
  }
  if (event.keyCode === 13) {
    // down
    event.preventDefault();
    row += 1;
    while (document.getElementById(`input_num${row}_${col}`).disabled === true)
      row += 1;
    document.getElementById(`input_num${row}_${col}`).focus();
    return false;
  }
  if (event.keyCode === 40 && event.target.type !== 'select') {
    // down
    event.preventDefault();
    row += 1;
    while (document.getElementById(`input_num${row}_${col}`).disabled === true)
      row += 1;
    document.getElementById(`input_num${row}_${col}`).focus();
    return false;
  }
}

export function copyCell(targetValue) {
  navigator.clipboard.writeText(targetValue);
}

export function copyCellHead(targetElement, properties, targetValue) {
  const flag = targetElement.indexOf('_', 9);
  const col = Number(targetElement.substring(flag + 1)) - 1;
  navigator.clipboard.writeText(`${properties[col].hdata}\n${targetValue}`);
}

export function copyRowHead(targetElement, properties, griddata) {
  const flag = targetElement.indexOf('_', 9);
  const row = Number(targetElement.substring(9, flag)) - 1;
  let head = '';
  properties.map((headers) => {
    head += `${headers.hdata}\t`;
    return head;
  });
  const rowdata = griddata[row];
  let text = '';
  properties.map((tags) => {
    text += `${rowdata[tags.tag]}\t`;
    return text;
  });
  navigator.clipboard.writeText(`${head}\n${text}`);
}

export function copyColHead(targetElement, properties, griddata) {
  const flag = targetElement.indexOf('_', 9);
  const col = Number(targetElement.substring(flag + 1)) - 1;
  let text = '';
  text += `${properties[col].hdata}\n`;
  const currenttag = properties[col].tag;
  griddata.map((rowdata) => {
    text += `${rowdata[currenttag]}\n`;
    return text;
  });
  navigator.clipboard.writeText(text);
}

export function copyTable(properties, griddata) {
  let head = '';
  properties.map((headers) => {
    head += `${headers.hdata}\t`;
    return head;
  });
  let text = '';
  griddata.map((griddata) => {
    properties.map((properties) => {
      text += `${griddata[properties.tag]}\t`;
      return text;
    });
    text += '\n';
    return text;
  });
  navigator.clipboard.writeText(`${head}\n${text}`);
}